const dominio = {
    dominio: process.env.VUE_APP_APP,
    api: process.env.VUE_APP_API,
    api_ari: process.env.VUE_APP_ARI,
    api_fds: process.env.VUE_APP_FDS,
    api_cal: process.env.VUE_APP_CAL,
    api_wor: process.env.VUE_APP_WOR
};

/**
 * Función auxiliar para manejar el operador de fusión nula
 *
 * @param {string|undefined} value - El valor a verificar
 * @returns {string} - El valor resultante
 */
function getValue(value) {
    return value !== undefined ? value : "";
}

/**
 * Obtener el dominio del API principal de Soluquim
 *
 * @returns {string}
 */
export function obtenerDominio() {
    return getValue(dominio.api);
}

/**
 * Obtener el dominio del API de Análisis de Riesgos de Soluquim
 *
 * @returns {string}
 */
export function obtenerDominioAnalisisRiesgos() {
    return getValue(dominio.api_ari);
}

/**
 * Obtener el dominio del API de Fichas de datos de seguridad de Soluquim
 *
 * @returns {string}
 */
export function obtenerDominioFDS() {
    return getValue(dominio.api_fds);
}

/**
 * Obtener el dominio del API de Calculadora de Soluquim.
 */
export function getDomainCalculator() {
    return getValue(dominio.api_cal);
}

/**
 * Obtener el dominio del API de Trabajadores de Soluquim.
 */
export function getDomainWorkers() {
    return getValue(dominio.api_wor);
}
